module.exports = __webpack_public_path__ + "img/thumbnail_GrizzlyBear_j_normal.54c5d853.png";